import { ConfirmModal } from '../../ui';
import sessionsService from '../../../services/sessionsServices';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Toast from '../../Toast';

const DeleteChatModal = ({ onClose, data }) => {
  const queryClient = useQueryClient();

  const handleSubmit = useMutation({
    mutationFn: async () => {
      return await sessionsService?.deleteSession({
        platform_id: 'chronolabs',
        session_id: data?.id,
        user_id: '123',
        agent_id: 'ferdy',
        project_id: 'test',
      });
    },
    retry: 1,
    onSuccess: response => {
      Toast({
        type: 'success',
        message: response.detail,
      });
      onClose();
      queryClient.invalidateQueries({ queryKey: ['sessions'] });
    },
    onError: err => {
      Toast({
        type: 'error',
        message: err.detail,
      });
    },
  });

  return (
    <ConfirmModal
      title="Delete Chat"
      message="Are you sure you want to delete this chat? There is no way to recover it."
      confirmLabel="Yes"
      busyLabel="Deleting..."
      loading={handleSubmit.isPending}
      onConfirm={() => handleSubmit.mutate()}
      onClose={onClose}
    />
  );
};

export default DeleteChatModal;
